export const environment = {
  production: true,
  backend: 'https://apps.cosy.bio/api-caddie/',
};
